var Align;
(function (Align) {
    Align["Left"] = "left";
    Align["Right"] = "right";
    Align["Center"] = "center";
})(Align || (Align = {}));
var DataTableStatus;
(function (DataTableStatus) {
    DataTableStatus["Loading"] = "loading";
    DataTableStatus["Error"] = "error";
    DataTableStatus["Default"] = "default";
})(DataTableStatus || (DataTableStatus = {}));

export { Align, DataTableStatus };
//# sourceMappingURL=DataTableProps.js.map
